import {
  sanitizeAnswersForOwen,
  sanitizeAnswerLabelForOwen,
  sanitizeTranscriptForOwen,
} from '../config/owenPrivacy';
import { buildQuestionCatalogForAi } from '../config/owenApplyQuestionCatalog';
import { buildDerivedAssessmentState } from './loanSizeTier';

export function buildOwenApplyPayload(params) {
  const allowedNextSteps = params.allowedNextSteps || [];
  return {
    mode: params.mode,
    answeredQuestionId: params.answeredQuestionId,
    answeredLabel: sanitizeAnswerLabelForOwen(
      params.answeredQuestionId,
      params.answeredLabel,
    ),
    answers: sanitizeAnswersForOwen(params.answers),
    readinessScore: params.readinessScore,
    recommendedPrograms: params.recommendedPrograms,
    allowedNextSteps,
    questionCatalog: buildQuestionCatalogForAi(allowedNextSteps),
    derivedState: buildDerivedAssessmentState(params.answers),
    transcript: sanitizeTranscriptForOwen(params.transcript),
  };
}
